const neofintechCode = function(state) {
  return state.neofintech.code
}

const neofintechData = function(state) {
  return {
    requestId: state.neofintech.requestId,
    phase: state.neofintech.phase,
    status: state.neofintech.status,
    email: state.neofintech.email,
    chosenLocation: state.neofintech.chosenLocation,
    candidates: state.neofintech.candidates,
    userData: state.neofintech.userData,
    ccRecipients: state.neofintech.ccRecipients,
    contactMethod: state.neofintech.contactMethod,
    createdAt: state.neofintech.createdAt,
    updatedAt: state.neofintech.updatedAt,
    phase1: {
      companyLocations: state.neofintech.phase1.companyLocations,
      countries: state.neofintech.phase1.countries,
      requesterCompanyTypes: state.neofintech.phase1.requesterCompanyTypes,
      economicSectors: state.neofintech.phase1.economicSectors,
      businessSectors: state.neofintech.phase1.businessSectors,
      capitalProgramTypes: state.neofintech.phase1.capitalProgramTypes,
      fundraisingProgramTypes: state.neofintech.phase1.fundraisingProgramTypes,
      programBeneficiaries: state.neofintech.phase1.programBeneficiaries,
    },
    phase2: {
      programCurrencyTypes: state.neofintech.phase2.programCurrencyTypes,
      requestedAmountRanges: state.neofintech.phase2.requestedAmountRanges,
      sellsAmountRanges: state.neofintech.phase2.sellsAmountRanges,
      ebidtaSign: state.neofintech.phase2.ebidtaSign,
      ebidta: state.neofintech.phase2.ebidtaAmountRanges,
      sellsForecast: state.neofintech.phase2.sellsForecast,
      hasAccountAuditor: state.neofintech.phase2.hasAccountAuditor,
      status: state.neofintech.phase2.status,
    }
  }
}


export default {
  neofintechData,
  neofintechCode
}
